import React, { useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { Button, Spinner, Alert, Container, Row, Col, Image, Card } from "react-bootstrap";
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import Style from "../../styles/components/layout/transferCSV.module.css";
import { db } from "../../firebaseConfig";

function TransferCSV() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [visualizedData, setVisualizedData] = useState([]);
  const [viewing, setViewing] = useState(false);
  const [stats, setStats] = useState(null); // Novo estado para estatísticas

  function converterParaCSV(objArray) {
    const array = Array.isArray(objArray) ? objArray : [objArray];
    if (array.length === 0) return "";
    const keys = Object.keys(array[0]);
    const csvRows = [keys.join(",")];

    array.forEach((item) => {
      const row = keys.map((key) => {
        const valor = item[key] != null ? item[key] : "";
        const escaped = ("" + valor).replace(/"/g, '""');
        return `"${escaped}"`;
      });
      csvRows.push(row.join(","));
    });
    return csvRows.join("\n");
  }

  const formatarDataPtBr = (timestamp) => {
    if (!timestamp) return "";
    if (timestamp.toDate) {
      const date = timestamp.toDate();
      return new Intl.DateTimeFormat('pt-BR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      }).format(date);
    }
    try {
      const date = new Date(timestamp);
      return new Intl.DateTimeFormat('pt-BR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      }).format(date);
    } catch (e) {
      console.error("Erro ao formatar data:", timestamp, e);
      return String(timestamp);
    }
  };

  const calcularEstatisticas = (dados) => {
    const total = dados.length;
    let masculinos = 0;
    let femininos = 0;
    let corrigidos = 0;
    let naoCorrigidos = 0;

    dados.forEach(doc => {
      if (doc.sexo && doc.sexo.toLowerCase() === 'masculino') {
        masculinos++;
      } else if (doc.sexo && doc.sexo.toLowerCase() === 'feminino') {
        femininos++;
      }

      if (doc.corrigido) {
        corrigidos++;
      } else {
        naoCorrigidos++;
      }
    });

    return {
      total,
      masculinos: {
        count: masculinos,
        percentage: total > 0 ? ((masculinos / total) * 100).toFixed(2) : 0
      },
      femininos: {
        count: femininos,
        percentage: total > 0 ? ((femininos / total) * 100).toFixed(2) : 0
      },
      corrigidos: {
        count: corrigidos,
        percentage: total > 0 ? ((corrigidos / total) * 100).toFixed(2) : 0
      },
      naoCorrigidos: {
        count: naoCorrigidos,
        percentage: total > 0 ? ((naoCorrigidos / total) * 100).toFixed(2) : 0
      }
    };
  };

  const buscarDadosParaVisualizacao = async () => {
    setLoading(true);
    setError("");
    setVisualizedData([]);
    setStats(null);
    setViewing(true);

    try {
      const querySnapshot = await getDocs(collection(db, "DATASET"));
      const dadosFormatados = [];

      querySnapshot.forEach((doc) => {
        const d = doc.data();
        const dadosLinha = {
          id: doc.id,
          altura: d?.DADOS?.ALTURA || "",
          peso: d?.DADOS?.PESO || "",
          idade: d?.DADOS?.IDADE || "",
          sexo: d?.DADOS?.sexo || "",
          contato: d?.DADOS?.contato || "",
          email: d?.DADOS?.email || "",
          dataNascimento: d?.DADOS?.dataNascimento || "",
          nivelAtividade: d?.DADOS?.nivelAtividade || "",
          consentimento: d?.DADOS?.consentimento ? "sim" : "não",
          antebraco: d?.CIRCUNFERENCIAS?.ANTEBRACO || "",
          biceps: d?.CIRCUNFERENCIAS?.BICEPS || "",
          cintura: d?.CIRCUNFERENCIAS?.CINTURA || "",
          coxa: d?.CIRCUNFERENCIAS?.COXA || "",
          panturrilha: d?.CIRCUNFERENCIAS?.PANTURRILHA || "",
          pescoco: d?.CIRCUNFERENCIAS?.pescoco || "",
          quadril: d?.CIRCUNFERENCIAS?.QUADRIL || "",
          imc: d?.DADOS_BIO?.imc || "",
          percentualGordura: d?.DADOS_BIO?.percentualGordura || "",
          metabolismoBasal: d?.DADOS_BIO?.metabolismoBasal || "",
          massaGordaKg: d?.DADOS_BIO?.massaGordaKg || "",
          massaGordaPorcentagem: d?.DADOS_BIO?.massaGordaPorcentagem || "",
          massaMagraKg: d?.DADOS_BIO?.massaMagraKg || "",
          massaMagraPorcentagem: d?.DADOS_BIO?.massaMagraPorcentagem || "",
          indiceMassaGorda: d?.DADOS_BIO?.indiceMassaGorda || "",
          indiceMassaMagra: d?.DADOS_BIO?.indiceMassaMagra || "",
          aguaCorporalKg:
            d?.DADOS_BIO?.aguaCorporalKg ||
            d?.DADOS_BIO?.aguaCorporalLitros || "",
          aguaCorporalPorcentagem: d?.DADOS_BIO?.aguaCorporalPorcentagem || "",
          fotoFrontal: d?.FOTOS?.fotoFrontal || "",
          fotoLateral: d?.FOTOS?.fotoLateral || "",
          createdAt: d?.createdAt || "",
          corrigido: d?.corrigido || false,
        };
        dadosFormatados.push(dadosLinha);
      });
      setVisualizedData(dadosFormatados);
      setStats(calcularEstatisticas(dadosFormatados)); // Calcula e define as estatísticas
    } catch (err) {
      console.error("Erro ao buscar dados para visualização:", err);
      setError("Erro ao buscar dados para visualização. Verifique o console.");
    }

    setLoading(false);
  };

  const gerarCSV = async () => {
    setLoading(true);
    setError("");
    setViewing(false);
    setStats(null); // Limpa as estatísticas ao gerar CSV

    try {
      const querySnapshot = await getDocs(collection(db, "DATASET"));
      const dados = [];

      querySnapshot.forEach((doc) => {
        const d = doc.data();
        const dadosLinha = {
          id: doc.id,
          altura: d?.DADOS?.ALTURA || "",
          peso: d?.DADOS?.PESO || "",
          idade: d?.DADOS?.IDADE || "",
          sexo: d?.DADOS?.sexo || "",
          contato: d?.DADOS?.contato || "",
          email: d?.DADOS?.email || "",
          dataNascimento: d?.DADOS?.dataNascimento || "",
          nivelAtividade: d?.DADOS?.nivelAtividade || "",
          consentimento: d?.DADOS?.consentimento ? "sim" : "não",
          antebraco: d?.CIRCUNFERENCIAS?.ANTEBRACO || "",
          biceps: d?.CIRCUNFERENCIAS?.BICEPS || "",
          cintura: d?.CIRCUNFERENCIAS?.CINTURA || "",
          coxa: d?.CIRCUNFERENCIAS?.COXA || "",
          panturrilha: d?.CIRCUNFERENCIAS?.PANTURRILHA || "",
          pescoco: d?.CIRCUNFERENCIAS?.pescoco || "",
          quadril: d?.CIRCUNFERENCIAS?.QUADRIL || "",
          imc: d?.DADOS_BIO?.imc || "",
          percentualGordura: d?.DADOS_BIO?.percentualGordura || "",
          metabolismoBasal: d?.DADOS_BIO?.metabolismoBasal || "",
          massaGordaKg: d?.DADOS_BIO?.massaGordaKg || "",
          massaGordaPorcentagem: d?.DADOS_BIO?.massaGordaPorcentagem || "",
          indiceMassaGorda: d?.DADOS_BIO?.indiceMassaGorda || "",
          indiceMassaMagra: d?.DADOS_BIO?.indiceMassaMagra || "",
          aguaCorporalKg:
            d?.DADOS_BIO?.aguaCorporalKg ||
            d?.DADOS_BIO?.aguaCorporalLitros || "",
          aguaCorporalPorcentagem: d?.DADOS_BIO?.aguaCorporalPorcentagem || "",
          fotoFrontal: d?.FOTOS?.fotoFrontal || "",
          fotoLateral: d?.FOTOS?.fotoLateral || "",
          createdAt: d?.createdAt || "",
          corrigido: d?.corrigido || false,
        };
        dados.push(dadosLinha);
      });

      const csv = converterParaCSV(dados);
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.setAttribute("download", "seu_dataset.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      console.error("Erro ao gerar CSV:", err);
      setError("Erro ao gerar CSV. Verifique o console.");
    }

    setLoading(false);
  };

  return (
    <div className={Style.container}>
      <h4 className="mb-3">Exportar e Visualizar Voluntários do Dataset</h4>
      {error && <Alert variant="danger">{error}</Alert>}
      <div className="d-flex gap-2 mb-4">
        <Button variant="primary" onClick={gerarCSV} disabled={loading}>
          {loading && !viewing ? (
            <>
              <Spinner animation="border" size="sm" /> Gerando CSV...
            </>
          ) : (
            "Gerar CSV"
          )}
        </Button>
        <Button variant="info" onClick={buscarDadosParaVisualizacao} disabled={loading}>
          {loading && viewing ? (
            <>
              <Spinner animation="border" size="sm" /> Buscando Dados...
            </>
          ) : (
            "Visualizar Dados"
          )}
        </Button>
      </div>

      {viewing && stats && (
        <Container className={`${Style.statsContainer} mb-4`}>
          <h5 className="mb-3">Estatísticas do Dataset:</h5>
          <Row>
            <Col md={4}>
              <Card className={Style.statsCard}>
                <Card.Body>
                  <Card.Title>Total de Registros</Card.Title>
                  <Card.Text>
                    <h3>{stats.total}</h3>
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className={Style.statsCard}>
                <Card.Body>
                  <Card.Title>Gênero</Card.Title>
                  <Card.Text>
                    <p>Masculino: {stats.masculinos.count} ({stats.masculinos.percentage}%)</p>
                    <p>Feminino: {stats.femininos.count} ({stats.femininos.percentage}%)</p>
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className={Style.statsCard}>
                <Card.Body>
                  <Card.Title>Status de Correção</Card.Title>
                  <Card.Text>
                    <p>Corrigidos: {stats.corrigidos.count} ({stats.corrigidos.percentage}%)</p>
                    <p>Não Corrigidos: {stats.naoCorrigidos.count} ({stats.naoCorrigidos.percentage}%)</p>
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      )}

      {visualizedData.length > 0 && viewing && (
        <Container className={Style.dataContainer}>
          <h5 className="mb-3">Dados Detalhados:</h5>
          {visualizedData.map((doc) => (
            <Row key={doc.id} className={Style.dataRow}>
              <Col md={3} className="d-flex align-items-center justify-content-center">
                {doc.fotoFrontal && (
                  <Image
                    src={`${doc.fotoFrontal}`}
                    alt="Foto Frontal"
                    className={Style.photo}
                    fluid
                  />
                )}
                {doc.fotoLateral && (
                  <Image
                    src={`${doc.fotoLateral}`}
                    alt="Foto Lateral"
                    className={Style.photo}
                    fluid
                  />
                )}
                {!doc.fotoFrontal && !doc.fotoLateral && <p>Nenhuma foto disponível</p>}
              </Col>
              <Col md={3} className="d-flex flex-column justify-content-center">
                <p><strong>Email:</strong> {doc.email}</p>
                <p><strong>Contato:</strong> {doc.contato}</p>
              </Col>
              <Col md={3} className="d-flex flex-column justify-content-center">
                <p><strong>Sexo:</strong> {doc.sexo}</p>
                <p><strong>Idade:</strong> {doc.IDADE}</p>
                <p><strong>Altura:</strong> {doc.ALTURA}</p>
                <p><strong>Peso:</strong> {doc.PESO}</p>
              </Col>
              <Col md={3} className="d-flex flex-column justify-content-center align-items-center">
                <p><strong>Criado em:</strong> {formatarDataPtBr(doc.createdAt)}</p>
                <div className="d-flex align-items-center">
                  <strong>Corrigido:</strong>
                  {doc.corrigido ? (
                    <FaCheckCircle className={Style.iconSuccess} size={20} />
                  ) : (
                    <FaTimesCircle className={Style.iconDanger} size={20} />
                  )}
                </div>
              </Col>
            </Row>
          ))}
        </Container>
      )}
      {!loading && visualizedData.length === 0 && viewing && (
        <Alert variant="info" className="mt-4">Nenhum dado encontrado para visualização.</Alert>
      )}
    </div>
  );
}

export default TransferCSV;